/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import Header from './header';
import Footer from './footer';

const Layout = ({ children, headerSolid }) => {
  return (
    <>
      <Helmet>
        <script
          src="https://js.sentry-cdn.com/0e22ad8255528bf7108631af1f888b2f.min.js"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Header forceSolid={headerSolid} />
      <main>{children}</main>
      <Footer />
    </>
  );
};

Layout.defaultProps = {
  headerSolid: false,
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headerSolid: PropTypes.bool,
};

export default Layout;
